import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["innerHTML"]

import BasketActionOfferConcentAccept from '@/storecontext/basket/ui/actions/offer/BasketActionOfferConcentAccept.vue';
import { B2CMyPersonalOfferConsentTileModel } from '@/types/B2CcontentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2CMyPersonalOfferConsentTile',
  props: {
    content: null
  },
  setup(__props: any) {



const success = ref<boolean>(false);

const onSuccess = () => {
    success.value = true;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (success.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: __props.content.acceptedConsentText
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  innerHTML: __props.content.termsAndConditionsText
                }, null, 8, _hoisted_3),
                _createVNode(BasketActionOfferConcentAccept, {
                  "agree-consent-checkbox-text": __props.content.agreeConsentCheckboxText,
                  onSuccess: onSuccess
                }, null, 8, ["agree-consent-checkbox-text"])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})